/* src/app/shared/components/file-preview/file-preview.component.scss */
/*# sourceMappingURL=file-preview.component.css.map */
